import { FuelButton, FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex, FuelSpacer } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import { useAppContext } from 'hooks/useAppContext';
import { useAppStates } from 'hooks/useAppStates';
import { useLoadTruckers } from 'hooks/useLoadTruckers';
import React, { FC } from 'react';
import { MAX_RADIUS_RANGE, RADIUS_RANGE_STEPS, getDisplayRangeValue, getNextRangeValue } from '../constants';
import * as Styled from './styled';

const EmptySuggestedList: FC = () => {
  const {
    state: {
      truckers: { radius },
      deviceSize: { isDesktop },
    },
    dispatch,
  } = useAppContext();

  const { isEmptySuggested, isErrorLoadSuggested } = useAppStates();

  const { fetchTruckers } = useLoadTruckers('lazy');

  const changeRadius = () => {
    dispatch({ type: 'truckers_radius', payload: { radius: getNextRangeValue(radius) } });
    fetchTruckers(getNextRangeValue(radius), 'botao-aumentar-raio');
  };

  const retry = () => {
    dispatch({ type: 'truckers_radius', payload: { radius } });
    fetchTruckers(radius, 'botao-tentar-novamente-falha-carregamento');
  };

  const messagesMap = {
    suggested: {
      title: 'Nenhum motorista sugerido',
      text: 'Não encontramos resultados para os filtros selecionados.',
    },
    loadDataError: {
      title: 'Não foi possível carregar a lista',
    },
  };

  return (
    <>
      {isEmptySuggested && (
        <FuelFlex
          defaultProps={{
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            customMargin: `${dsTheme.spacing.km16} 0 0`,
          }}
          testId="suggested-empty-state"
        >
          <FuelSign icon="search" iconStyle="outlined" size="medium" />
          <FuelSpacer orientation="vertical" y="km8" />
          <FuelTypography size="heading-sm" weight="bold" tag="h4" color="neutral-strong">
            {messagesMap.suggested.title}
          </FuelTypography>
          <Styled.TextWrapper>
            <FuelTypography size="body-sm">{messagesMap.suggested.text}</FuelTypography>
          </Styled.TextWrapper>

          {!isDesktop && +radius + RADIUS_RANGE_STEPS <= MAX_RADIUS_RANGE && (
            <FuelFlex
              defaultProps={{
                alignItems: 'center',
                justifyContent: 'center',
                customMargin: `${dsTheme.spacing.km12} 0 0`,
                width: '80%',
              }}
            >
              <FuelButton onClick={() => changeRadius()} variant="primary" size="large">
                Aumentar raio para {getDisplayRangeValue(radius)}km
              </FuelButton>
            </FuelFlex>
          )}
        </FuelFlex>
      )}

      {isErrorLoadSuggested && (
        <FuelFlex
          defaultProps={{
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            customMargin: `${dsTheme.spacing.km16} 0 0`,
          }}
          testId="suggested-error-state"
        >
          <FuelTypography size="heading-sm" weight="bold" tag="h4" color="neutral-strong">
            {messagesMap.loadDataError.title}
          </FuelTypography>

          {!isDesktop && (
            <FuelFlex
              defaultProps={{
                alignItems: 'center',
                justifyContent: 'center',
                customMargin: `${dsTheme.spacing.km12} 0 0`,
                width: '80%',
              }}
            >
              <FuelButton onClick={() => retry()} variant="primary" size="large">
                Tentar novamente
              </FuelButton>
            </FuelFlex>
          )}
        </FuelFlex>
      )}
    </>
  );
};

export default EmptySuggestedList;
